import { action } from 'typesafe-actions';

import { TimeOption } from 'components/FlightsSearch/components/FlightTimePicker/models';
import { Airport } from 'models/airport';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { FlightExchangeResponse, FlightExchangeState } from 'models/flightExchange';
import { FlightFilter } from 'models/flightFilter';
import {
  FlightResultResponse,
  FlightSearchResponse,
  FlightResultRequestOrderCriteriaEnum,
  FlightStretch,
} from 'models/flightSearch';
import { FlightTabFilterResponse } from 'models/flightTabFilter';
import { MultidestinationTrip } from 'models/multiDestinationTrip';
import { TravelArrangerUsersAllowed } from 'services/userService';

export const FLIGHTS_SEARCH_REQUEST = 'FLIGHTS_SEARCH_REQUEST';
export const FLIGHTS_SEARCH_SUCCESSFUL = 'FLIGHTS_SEARCH_SUCCESSFUL';
export const FLIGHTS_SEARCH_FAILURE = 'FLIGHTS_SEARCH_FAILURE';
export const FLIGHTS_RESULT_REQUEST = 'FLIGHTS_RESULT_REQUEST';
export const FLIGHTS_RESULT_SUCCESSFUL = 'FLIGHTS_RESULT_SUCCESSFUL';
export const FLIGHTS_RESULT_FAILURE = 'FLIGHTS_RESULT_FAILURE';
export const FLIGHTS_SEARCH_PARAMETERS = 'FLIGHTS_SEARCH_PARAMETERS';
export const FLIGHTS_RESULT_CLEAR = 'FLIGHTS_RESULT_CLEAR';
export const FLIGHTS_FILTER_CLEAR = 'FLIGHTS_FILTER_CLEAR';
export const FLIGHTS_CLEAR = 'FLIGHTS_CLEAR';
export const FLIGHTS_TAB_FILTER = 'FLIGHTS_TAB_FILTER';
export const FLIGHTS_DIRECT_FILTER = 'FLIGHTS_DIRECT_FILTER';
export const FLIGHTS_SET_TRAVELER = 'FLIGHTS_SET_TRAVELER';
export const FLIGHTS_EXCHANGE_PARAMETERS = 'FLIGHTS_EXCHANGE_PARAMETERS';
export const FLIGHTS_EXCHANGE_REQUEST = 'FLIGHTS_EXCHANGE_REQUEST';
export const FLIGHTS_EXCHANGE_SUCCESSFUL = 'FLIGHTS_EXCHANGE_SUCCESSFUL';
export const FLIGHTS_EXCHANGE_FAILURE = 'FLIGHTS_EXCHANGE_FAILURE';
export const FLIGHTS_EXCHANGE_CLEAR = 'FLIGHTS_EXCHANGE_CLEAR';
export const FLIGHTS_EXCHANGE_OPTIONS = 'FLIGHTS_EXCHANGE_OPTIONS';
export const FLIGHTS_EXCHANGE_RESULT_REQUEST = 'FLIGHTS_EXCHANGE_RESULT_REQUEST';
export const FLIGHTS_EXCHANGE_RESULT_SUCCESSFUL = 'FLIGHTS_EXCHANGE_RESULT_SUCCESSFUL';
export const FLIGHTS_EXCHANGE_RESULT_FAILURE = 'FLIGHTS_EXCHANGE_RESULT_FAILURE';
export const FLIGHTS_EXCHANGE_RESULT_CLEAR = 'FLIGHTS_EXCHANGE_RESULT_CLEAR';
export const FLIGHTS_SET_TRAVELERS = 'FLIGHTS_SET_TRAVELERS';
export const FLIGHTS_CHANGE_RESULT_BY_SECTOR_PAGINATION = 'FLIGHTS_CHANGE_RESULT_BY_SECTOR_PAGINATION';
export const FLIGHTS_RESULT_BY_SECTOR_SUCCESSFUL ='FLIGHTS_RESULT_BY_SECTOR_SUCCESSFUL';
export const ADD_OPTION_ID_BY_SECTOR = 'ADD_OPTION_ID_BY_SECTOR';
export const REMOVE_OPTION_ID_BY_SECTOR = 'REMOVE_OPTION_ID_BY_SECTOR';
export const SELECT_FLIGHT_BY_SECTOR_SUCCESSFUL = 'SELECT_FLIGHT_BY_SECTOR_SUCCESSFUL';
export const FLIGHTS_RESULT_BY_SECTOR_SUCCESSFUL_FILTERS ='FLIGHTS_RESULT_BY_SECTOR_SUCCESSFUL_FILTERS';
export const FLIGHTS_AIR_SEARCH_TYPE ='FLIGHTS_AIR_SEARCH_TYPE';
export const FLIGHTS_PAGINATION_CLEAR = 'FLIGHTS_PAGINATION_CLEAR';
export const FLIGHTS_OPTIONS_IDS_CLEAR = 'FLIGHTS_OPTIONS_IDS_CLEAR';
export const FLIGHTS_CONFIRMATION_SUCCESSFUL = 'FLIGHTS_CONFIRMATION_SUCCESSFUL';
export const FLIGHTS_CONFIRMATION_FAILURE = 'FLIGHTS_CONFIRMATION_FAILURE';
export const CLEAR_CONFIRMATION = 'CLEAR_CONFIRMATION';
export const FLIGHTS_SEARCH_CLEAR = 'FLIGHTS_SEARCH_CLEAR';
type FlightsSearchRequestArguments = {
  baggageIncluded: boolean;
  departurePoint: Airport;
  arrivalPoint: Airport;
  departureDate: Date;
  cabin: string;
  returnDate?: Date;
  travelers?: TravelArrangerUsersAllowed[];
  departureTime?: TimeOption;
  returnTime?: TimeOption;
  directFlight: boolean;
  branchCompany?: GetAllBillingCompanyResponse;
  multiDestinationTrips?: MultidestinationTrip[];
  flightStretch?: FlightStretch;
};

export const flightsSearchRequest = ({
  baggageIncluded,
  departurePoint,
  arrivalPoint,
  departureDate,
  cabin,
  returnDate,
  travelers,
  departureTime,
  returnTime,
  directFlight,
  branchCompany,
  multiDestinationTrips,
  flightStretch,
}: FlightsSearchRequestArguments) =>
  action(FLIGHTS_SEARCH_REQUEST, {
    departurePoint,
    arrivalPoint,
    departureDate,
    cabin,
    returnDate,
    baggageIncluded,
    travelers,
    departureTime,
    returnTime,
    directFlight,
    branchCompany,
    multiDestinationTrips,
    flightStretch,
  });

export const setFlightsDirectFilter = (isDirectFlightsFilterChecked: boolean) =>
  action(FLIGHTS_DIRECT_FILTER, isDirectFlightsFilterChecked);

export const flightsTabFilterSuccessful = (flightTabFilter: FlightTabFilterResponse) =>
  action(FLIGHTS_TAB_FILTER, flightTabFilter);

export const flightsSearchSuccessful = (search: FlightSearchResponse) => action(FLIGHTS_SEARCH_SUCCESSFUL, search);

export const flightsSearchError = (error: string) => action(FLIGHTS_SEARCH_FAILURE, error);

export const flightResultsRequest = (orderCriteria: FlightResultRequestOrderCriteriaEnum, filters?: FlightFilter) =>
  action(FLIGHTS_RESULT_REQUEST, {
    orderCriteria,
    filters,
  });

export const flightResultsSuccessful = (result: FlightResultResponse[]) => action(FLIGHTS_RESULT_SUCCESSFUL, result);
export const flightResultsBySectorSuccessful = (result: FlightResultResponse[]) => action(FLIGHTS_RESULT_BY_SECTOR_SUCCESSFUL, result);
export const flightResultsBySectorSuccessfulFilter = (result: FlightResultResponse[]) => action(FLIGHTS_RESULT_BY_SECTOR_SUCCESSFUL_FILTERS, result);
export const selectFlightBySectorSuccessful = (result: FlightResultResponse[]) => action(SELECT_FLIGHT_BY_SECTOR_SUCCESSFUL, result);
export const changeResultBySectorPagination= (countLowerBound, countUpperBound) => action(FLIGHTS_CHANGE_RESULT_BY_SECTOR_PAGINATION, {countLowerBound, countUpperBound});

export const addOptionIdBySector = (optionId) => action(ADD_OPTION_ID_BY_SECTOR, optionId);
export const removeOptionIdBySector = (optionId) => action(REMOVE_OPTION_ID_BY_SECTOR, optionId);
export const setAirSearchType = (searchType) => action(FLIGHTS_AIR_SEARCH_TYPE, searchType);

export const flightResultsError = (error: string) => action(FLIGHTS_RESULT_FAILURE, error);

export const flightResultsClear = () => action(FLIGHTS_RESULT_CLEAR);

export const flightsFilterClear = () => action(FLIGHTS_FILTER_CLEAR);

export const setConfirmationSuccessful = (confirmation) => action(FLIGHTS_CONFIRMATION_SUCCESSFUL, confirmation);

export const setConfirmationError = (error) => action(FLIGHTS_CONFIRMATION_FAILURE, error);

export const flightsClear = () => action(FLIGHTS_CLEAR);

export const flightsClearSearch = () => action(FLIGHTS_SEARCH_CLEAR);

export const flightsClearPagination = () => action(FLIGHTS_PAGINATION_CLEAR);

export const flightsClearConfirmation = () => action(CLEAR_CONFIRMATION);

export const flightsClearOptionsIds = () => action(FLIGHTS_OPTIONS_IDS_CLEAR);

export const flightsSetTraveler = (traveler?: TravelArrangerUsersAllowed) => action(FLIGHTS_SET_TRAVELER, traveler);

export const flightsExchangeParameters = (flight: FlightExchangeState) => action(FLIGHTS_EXCHANGE_PARAMETERS, flight);

export const flightsExchangeOptions = (options: { changeDeparture: boolean; changeArrival: boolean }) =>
  action(FLIGHTS_EXCHANGE_OPTIONS, options);

export const flightsExchangeRequest = (flight: FlightExchangeState) => action(FLIGHTS_EXCHANGE_REQUEST, flight);

export const flightsExchangeSuccessful = (result: FlightExchangeResponse) =>
  action(FLIGHTS_EXCHANGE_SUCCESSFUL, result);

export const flightsExchangeError = (error: string) => action(FLIGHTS_EXCHANGE_FAILURE, error);

export const flightsExchangeClear = () => action(FLIGHTS_EXCHANGE_CLEAR);

export const flightsExchangeResultsRequest = (
  orderCriteria: FlightResultRequestOrderCriteriaEnum,
  filters?: FlightFilter,
) =>
  action(FLIGHTS_EXCHANGE_RESULT_REQUEST, {
    orderCriteria,
    filters,
  });

export const flightsExchangeResultsSuccessful = (result: FlightResultResponse[]) =>
  action(FLIGHTS_EXCHANGE_RESULT_SUCCESSFUL, result);

export const flightsExchangeResultsError = (error: string) => action(FLIGHTS_EXCHANGE_RESULT_FAILURE, error);

export const flightsExchangeResultsClear = () => action(FLIGHTS_EXCHANGE_RESULT_CLEAR);

export const flightsSearchParameters = ({
  baggageIncluded,
  departurePoint,
  arrivalPoint,
  departureDate,
  cabin,
  returnDate,
  travelers,
  departureTime,
  returnTime,
  directFlight,
  branchCompany,
  multiDestinationTrips,
  flightStretch,
}: FlightsSearchRequestArguments) =>
  action(FLIGHTS_SEARCH_PARAMETERS, {
    departurePoint,
    arrivalPoint,
    departureDate,
    cabin,
    returnDate,
    baggageIncluded,
    travelers,
    departureTime,
    returnTime,
    directFlight,
    branchCompany,
    multiDestinationTrips,
    flightStretch,
  });

export const flightsSetTravelers = (travelers?: TravelArrangerUsersAllowed[]) =>
  action(FLIGHTS_SET_TRAVELERS, travelers);
